export const requestExtraPickupData = [
  {
    Question: `How do I connect with you quickly to request an Extra Pickup?`,
    Answer: `Need a quick way to schedule an Extra Pickup? Connect with us quickly:  

        <ul><li>For residential customers, please <a href=’https://www.wm.com/us/en/support#support’>Contact Us.</a></li> 
        
        <li>For commercial customers, please <a href=’https://www.wm.com/us/en/support#support’>Contact Us.</a></li></ul>`,
  },
]
